import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import * as moment from "moment";
import { CalendarService } from "@/services/calendar/calendar.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-date",
  templateUrl: "./date.component.html",
  styleUrls: ["./date.component.scss"],
})
export class DateComponent implements OnInit {
  @Input() ngModelVar: any;
  @Input() isDisable: any;
  @Input() moreClass: any;
  @Input() min = moment().format("YYYY-MM-DD");
  @Input() max = null;
  @Input() placeholder = "dd/mm/yyyy";
  @Input() isNotEndDateUserInfo: boolean = true;
  @Input() dateFormatValue: any;
  @Input() wantHoliday = true;

  @Output() date = new EventEmitter<string>();

  @ViewChild("myinput") myInput;

  // today = moment().format('YYYY-MM-DD');
  holiday: any[] = [];
  isHoliday = false;

  checked = "";

  constructor(private serviceCalendar: CalendarService) {}

  ngOnInit(): void {
    if(this.wantHoliday) {
      this.serviceCalendar.getMsCalendarAll().subscribe((res) => {
        for (var i = 0; i < res.length; i++) {
          this.holiday.push(moment(res[i].dayOff).format("YYYY-MM-DD"));
        }
      });
    }

    if (this.ngModelVar) {
      this.ngModelVar = moment(this.ngModelVar, [
        "YYYY-MM-DD",
        "DD/MM/YYYY",
      ]).format("DD/MM/YYYY");
      this.dateFormatValue = moment(this.ngModelVar, [
        "YYYY-MM-DD",
        "DD/MM/YYYY",
      ]).format("YYYY-MM-DD");
    }
  }

  changeInputDate(e: any) {
    var startDate = moment(e.target.value);
    console.log(startDate);
    if(this.wantHoliday) {
      if (startDate.isoWeekday() == 6 || startDate.isoWeekday() == 7) {
        // e.target.value = startDate
        //   .add(7 - startDate.isoWeekday() + 1, "day")
        //   .format("YYYY-MM-DD");
        //alert cant choose weekend
        // Swal.fire({
        //   icon: "error",
        //   title: "Oops...",
        //   text: "Can't choose weekend!",
        // })
        this.ngModelVar = moment(startDate).format("DD/MM/YYYY");
        this.dateFormatValue = moment(this.ngModelVar, [
          "YYYY-MM-DD",
          "DD/MM/YYYY",
        ]).format("YYYY-MM-DD");
        this.date.emit(e.target.value);
        return;
      } else if (this.holiday.includes(startDate.format("YYYY-MM-DD"))) {
        // e.target.value = startDate.add(1, "day").format("YYYY-MM-DD");
        // Swal.fire({
        //   icon: "error",
        //   title: "Oops...",
        //   text: "Can't choose holiday!",
        // })
        this.ngModelVar = moment(startDate).format("DD/MM/YYYY");
        this.dateFormatValue = moment(this.ngModelVar, [
          "YYYY-MM-DD",
          "DD/MM/YYYY",
        ]).format("YYYY-MM-DD");
        this.date.emit(e.target.value);
        return;
        // this.isHoliday = true;
        // while (this.isHoliday) {
        //   if (startDate.isoWeekday() == 6 || startDate.isoWeekday() == 7) {
        //     // e.target.value = startDate
        //     //   .add(7 - startDate.isoWeekday() + 1, "day")
        //     //   .format("YYYY-MM-DD");
        //     // continue;
        //     Swal.fire({
        //       icon: "error",
        //       title: "Oops...",
        //       text: "Can't choose weekend!",
        //     })
        //     this.date.emit('');
        //     return;
        //   }
        //   if (this.holiday.includes(startDate.format("YYYY-MM-DD"))) {
        //     // e.target.value = startDate.add(1, "day").format("YYYY-MM-DD");
        //     Swal.fire({
        //       icon: "error",
        //       title: "Oops...",
        //       text: "Can't choose weekend!",
        //     })
        //     this.date.emit('');
        //     return;
        //   }
        //   this.isHoliday = false;
        // }
        // alert("** Unable to choose traditional holidays **");
      }
    }
    this.ngModelVar = moment(startDate).format("DD/MM/YYYY");
    this.dateFormatValue = moment(this.ngModelVar, [
      "YYYY-MM-DD",
      "DD/MM/YYYY",
    ]).format("YYYY-MM-DD");
    this.date.emit(e.target.value);
  }

  formatValue(value: any) {}

  showPicker(e: any) {
    // this.dateValue = moment(this.ngModelVar, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD");
    this.myInput.nativeElement.showPicker();
  }
}
